<template>
    <h2>Preferences</h2>

    <div v-if="isLoading" style="max-height: 66px; margin-left: 10px;">
        <loader></loader>
    </div>
    <div v-if="!isLoading">
        <Form @submit="onSubmit" >
            <h3>Email Preferences</h3>

            <div class="row">
                <div class="col-xl-8">

                    <div class="email-preference" v-for="(addressBook, index) in addressBookFullList">
                        <span>{{addressBook.title}}</span>
                        <label class="switch">
                            <Field name="addressBooks"
                                   type="checkbox"
                                      v-model="addressBooks"
                                   v-bind:value="addressBook.id"></Field>

                     
                             <span class="slider round"></span>
                        </label>

                    </div>

                    <div class="mt-3">
                        <button class="btn btn--slate-blue" type="submit">
                            Update Preferences
                        </button>
                    </div>

                </div>
            </div>
        </Form>
    </div>
</template>

<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import Loader from '@/shared/components/Loader.vue';
    import marketingApi from '@/shared/api/marketing';
    import { accountStore } from '../store/index';
    export default {
        name: 'AccountPreferences',
        components: {
            Loader,
            Field,
            Form,
            ErrorMessage,
        },
        mounted() {
            let so = this;
            so.isLoading = true;
            marketingApi.getAddressBooks(this.userProfile.EmailAddress, t => {
          
                so.addressBooks = t;
                so.isLoading = false;
            });
        },
        computed: {
            userProfile() {
                return accountStore.getters.userProfile;
            },
            addressBookFullList() {
                return [
                    {
                        id: '21980355',
                        title: 'Offers and promotions',
                        isOn: true
              
                    },
                    {
                        id: '3508013',
                        title: 'Golf',
                 
                    },
                    {
                        id: '3507983',
                        title: 'Spa',
             
                    },
                    {
                        id: '3507997',
                        title: 'Hotel',
                  
                    },
                    {
                        id: '3508001',
                        title: 'Restaurant',
              
                    },
                    {
                        id: '3508068',
                        title: 'Events',
             
                    }
                ];
            }
        },
        data() {
           

            return {
                isLoading: false,
                addressBooks: []
            }
        },
        methods: {

            onSubmit(values) {
    
                let arr = Object.values(values)[0] || [];
                let o = this;
                o.isLoading = true;
                let addressDatafields = [];
                if (this.userProfile.Address != null) {
                    addressDatafields = [{
                        "Key": "ADDRESS1",
                        "Value": this.userProfile.Address.Line1
                    },
                    {
                        "Key": "ADDRESS2",
                        "Value": this.userProfile.Address.Line2
                    },
                    {
                        "Key": "CITY",
                        "Value": this.userProfile.Address.City
                    },
                    {
                        "Key": "POSTCODE",
                        "Value": this.userProfile.Address.PostCode
                    }];
                }

                let fullList = this.addressBookFullList;

                let toRemove = [];
                for (let item = 0; item < fullList.length; item++) {
                    let ad = fullList[item].id;
                    //for some reason, includes doesnt work here...
               
                    let included = false;
                  
                    for (let i = 0; i < arr.length; i++) {
                        let ai = arr[i];
                        if (ai == ad) {
                            included = true;
                            break;
                        }
                    }

                    if (!included) {
                        toRemove.push(ad);
                    }

                    //if (!arr.includes(ad)) { toRemove.push(ad) };
                }
           
                let payload = {
                    emailAddress: this.userProfile.EmailAddress,
                    addressBooks: arr,
                    dataFields: [
                        ...addressDatafields,
                        {
                            "Key": "TITLE",
                            "Value": this.userProfile.Title,
                        },
                        {
                            "Key": "FIRSTNAME",
                            "Value": this.userProfile.FirstName,
                        },
                        {
                            "Key": "LASTNAME",
                            "Value": this.userProfile.LastName,
                        }

                    ]
                }
                if (this.userProfile.Birthdate != null) {
                    payload.dataFields.push({
                        "Key": "DATE_OF_BIRTH",
                        "Value": moment(this.userProfile.Birthdate).format("YYYY-MM-DD")
                    })
                }

                if (toRemove.length) {
                    let upayload = {
                        emailAddress: this.userProfile.EmailAddress,
                        addressBooks: toRemove
                    }
                    marketingApi.unsubscribe(upayload, t => {


                        marketingApi.subscribe(payload, u => {
                            o.addressBooks = u;

                            o.isLoading = false;
                        });
                    });
                } else {
                    marketingApi.subscribe(payload, u => {
                        o.addressBooks = u;

                        o.isLoading = false;
                    });
                }



            }
        }
    }
</script>

<style>
    .email-preference {
        padding: 30px 0;
        border-bottom: solid 1px #eee9e7;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

        /* Hide default HTML checkbox */
        .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
            position: absolute;
            content: "";
            height: 26px;
            width: 26px;
            left: 4px;
            bottom: 4px;
            background-color: #b2533d;
            -webkit-transition: .4s;
            transition: .4s;
        }

    input + .slider {
        background-color: rgba(178,83,61,0.2);
    }

    input:checked + .slider {
        background-color: rgba(55,81,60,0.2);
    }

        input:checked + .slider:before {
            background-color: #37513c;
        }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

        .slider.round:before {
            border-radius: 50%;
        }
</style>
